<span class="d-block" *ngFor="let variant of pimProductVariants">{{ variant.id }} - {{ variant.name }}</span>
